// Creates FridgeContext and exports it
import {createContext} from 'react'

const FridgeContext = createContext()

export {FridgeContext}